module.exports = __webpack_public_path__ + "img/beauty_teeth-whitening.0af6ea3.svg";